import type { GetEntitiesRequest } from '@backstage/catalog-client';
import type { Entity } from '@backstage/catalog-model';
import type { RouteRef } from '@backstage/frontend-plugin-api';

import {
  createExtensionBlueprint,
  createExtensionDataRef,
} from '@backstage/frontend-plugin-api';

import type { IPenThemes } from '../theme/customTheme';
import type { Icon } from '../types';

/**
 * Defines a dynamic nav structure, where the items are defined by an entity-filter
 */
export type EntityFilterNavItem = {
  fallbackIcon: Icon;
  featureFlag?: string;
  filter: GetEntitiesRequest['filter'];
  pageTheme?: IPenThemes;
};

export type NavItem = {
  description?: string;
  entityMatcher?: (entity: Entity) => boolean;
  featureFlag?: string;
  icon?: Icon;
  pageTheme?: IPenThemes;
  routeRef?: RouteRef<undefined>;
  skipIconWrapping?: boolean;
  target: string;
  title: string;
};

export type NavItemOrFilter = EntityFilterNavItem | NavItem;

const targetDataRef = createExtensionDataRef<NavItemOrFilter>().with({
  id: 'core.nav-item.target',
});

export const EnhancedNavItemBlueprint = createExtensionBlueprint({
  attachTo: { id: 'app/nav', input: 'items' },
  dataRefs: {
    target: targetDataRef,
  },
  * factory(props: NavItemOrFilter) {
    yield targetDataRef(props);
  },
  kind: 'nav-item',
  output: [targetDataRef],
});
